class ContentSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const { Swiper } = this.swiperLib;

    const swiperParams = {
      slidesPerView: "auto",
      speed: 300,
      spaceBetween: 40,
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      breakpoints: {
        960: {
          spaceBetween: 80,
        },
      },
      on: {
        lock: () => {
          this.classList.add("content-slider--locked");
        },
        unlock: () => {
          this.classList.remove("content-slider--locked");
        },
      },
    };

    this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
  }
}

if (!customElements.get("content-slider")) {
  customElements.define("content-slider", ContentSlider);
}
